module.exports = __webpack_public_path__ + "img/sex_w.75b07e80.svg";